// src/components/AddEditMainProduct.jsx
import React, { useState, useEffect } from "react";
import { Box, Button, TextField, Typography, Grid } from "@mui/material";
import { grey } from "@mui/material/colors";

const AddEditMainProduct = ({ onClose, onSave, editData }) => {
    const [formData, setFormData] = useState({
        product_name: "",
        full_name: "",
        descrip: ""
    });

    useEffect(() => {
        if (editData) {
            // console.log("Edit data received:", editData); // Debugging line
            setFormData(editData);
        }
    }, [editData]);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData(prevState => ({
            ...prevState,
            [name]: value
        }));
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        onSave(formData);
    };

    return (
        <>
        {/* Header */}
        <Box sx={{ mb: 3, borderBottom: `2px solid ${grey[300]}`, paddingBottom: 1, bgcolor: grey[200], p: 2, textAlign: "center" }}>
                <Typography variant="h6" fontWeight="bold" sx={{ textAlign: "center", mb: 1, mt: 1 }}>
                    {editData ? "Edit Product" : "Add Product"}
                </Typography>
        </Box>
        <Box sx={{ ml: 2, mt: 2, mr: 2, mb: 0, p: 2, border: "1px solid #ccc", borderRadius: 2 }}>
            <Box sx={{ display: "flex", gap: 2, marginTop: 1, marginBottom: 1 }}>
            <form onSubmit={handleSubmit}>
                <Grid container spacing={2}>
                    <Grid item xs={12}>
                        <TextField fullWidth margin="dense" size="small" label="Enter Product" name="product_name" value={formData.product_name} onChange={handleChange} />
                    </Grid>
                    <Grid item xs={12}>
                        <TextField fullWidth margin="dense" size="small" label="Full Name" name="full_name" value={formData.full_name} onChange={handleChange} />
                    </Grid>
                    <Grid item xs={12}>
                        <TextField fullWidth margin="dense" size="small" label="Description" name="descrip" value={formData.descrip} onChange={handleChange} 
                            multiline
                            rows={3}
                        />
                    </Grid>
                </Grid>

                {/* Buttons */}
                <Box sx={{ mt: 3, borderTop: `2px solid ${grey[300]}`, paddingTop: 3, display: "flex", justifyContent: "space-between" }}>
                    <Button variant="contained" size="small" color="success" sx={{ fontSize: "0.65rem", padding: "3px 6px" }} type="submit">
                        Save
                    </Button>
                    <Button variant="outlined" size="small" color="error" sx={{ fontSize: "0.65rem", padding: "3px 6px" }} onClick={onClose}>
                        Cancel
                    </Button>
                </Box>
            </form>
            </Box>

            {/* Footer */}
            {/* <Box sx={{ mt: 3, borderTop: `2px solid ${grey[300]}`, paddingTop: 1, textAlign: "center" }}>
                <Typography variant="caption" color="textSecondary">
                    Please ensure all fields are filled correctly.
                </Typography>
            </Box> */}
        </Box>
        </>
    );
};

export default AddEditMainProduct;